import { useEffect } from "react";

declare global {
  interface Window {
    dataLayer: any[];
     Trengo: { key: string };
  }
}

export const useDataLayerPageView = (url: string) => {
  useEffect(() => {
    if (typeof window !== "undefined" && typeof window.dataLayer !== "undefined") {
      window.dataLayer.push({
        event: 'pageview',
        page: url,
        ecommerce: {}
      })
    }
  }, [url]);
}
